module.exports = __webpack_public_path__ + "static/media/ActivePure Logo.bae3e5ef.png";